import { colors } from '@smartsheet/lodestar-core';

export const railBgDefault = '#003059';
export const railBgCustom = '#000000';
export const railButtonHoverBg = 'rgba(255, 255, 255, 0.35)';
export const railButtonFocusBorder = 'rgba(179, 204, 234, 0.8)';

export const panelBg = colors.neutralLight40;
